module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comments-comp"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__content"
  }, [_c('div', {
    staticClass: "box__initComment"
  }, [_c('div', {
    staticClass: "ci"
  }, [_c('div', {
    staticClass: "ci__header"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.currentUser.slug))
    }
  }, [_c('div', {
    staticClass: "ci__image",
    class: {
      roundAvatar: _vm.roundAvatar
    },
    style: (("background-image: url(" + (_vm.currentUser.avatar.url) + "); height: " + _vm.aviHeight + "px; width: " + _vm.aviWidth + "px;"))
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "ci__content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentText),
      expression: "commentText",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      roundInput: _vm.roundInput
    },
    attrs: {
      "type": "text",
      "placeholder": "Leave a comment..."
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addComment()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), (!_vm.hideCommentCount) ? _c('div', {
    staticClass: "comment__count"
  }, [_vm._v(_vm._s(_vm.comments.length) + " " + _vm._s(_vm._f("pluralize")("comment", _vm.comments.length)))]) : _vm._e(), _vm._v(" "), (!_vm.hideComments) ? _c('chat', {
    attrs: {
      "items": _vm.comments
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5de59cd6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comments/index.vue
// module id = 1738
// module chunks = 180